import { Button, ButtonProps, Menu, Stack, Checkbox, FormControlLabel } from "@mui/material";
import ViewColumnOutlinedIcon from '@mui/icons-material/ViewColumnOutlined';
import { useState, ReactNode } from "react";
import { useColumnsReturn } from "@/components/data-table";

export interface HeaderColumnButtonProps extends ButtonProps {
    columnData: useColumnsReturn
}

export default function HeaderColumnButton({
    columnData,
    onClick,
    ...props
}: HeaderColumnButtonProps) {
    const [anchorEl, setAnchorEl] = useState<Element | undefined>(undefined);

    const { columns, setColumn } = columnData;

    return <>
        <Button size="small" startIcon={<ViewColumnOutlinedIcon />} onClick={(e) => {
            onClick && onClick(e);
            setAnchorEl(e.currentTarget);
        }} {...props}>
            Columnas
        </Button>
        <Menu open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={() => setAnchorEl(undefined)}>
            <Stack paddingX={2}>
                {columns.map(({ key, header, show }) => <ColumnCheckBox
                    key={key}
                    label={header}
                    value={show}
                    setValue={value => setColumn(key, { show: value })}
                />)}
            </Stack>
        </Menu>
    </>
}

export interface ColumnCheckBoxProps{
    label:ReactNode,
    value:boolean,
    setValue:(v:boolean)=>void
}

function ColumnCheckBox({
    label,
    value, 
    setValue
}:ColumnCheckBoxProps){
    return <FormControlLabel 
        control={<Checkbox checked={value} onChange={e=>setValue(e.target.checked)}/>} 
        label={label} 
    />
}